import { createContext, useContext } from 'react';
import { useReadCompany } from '../hooks';
import {
  CompanyReadDataContextData as ContextData,
  CompanyReadDataContextProps as ContextProps,
} from './types';

const context = createContext<ContextData>({} as ContextData);

const { Provider } = context;

export const useCompanyReadDataContext = () => useContext(context);

export const CompanyReadDataProvider = ({ children, id }: ContextProps) => {
  const api = useReadCompany(id);

  return (
    <Provider
      value={{
        api,
        id,
      }}
    >
      {children}
    </Provider>
  );
};
